<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" :rules="formRules" ref="queryForm" :inline="true">
          <div class="flex-box">
            <el-form-item label="服务签到时间：">
              <el-date-picker v-model="busTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="时间粒度：">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{query.timeType === 2?'周':'月'}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item command="1">日</el-dropdown-item> -->
                  <el-dropdown-item command="3">月</el-dropdown-item>
                  <el-dropdown-item command="2">周</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <img src="../../../assets/down.png" class="down" alt="">
            </el-form-item>
          </div>
          <el-form-item label="技术老师：">
            <el-select v-model="query.technicianId" filterable placeholder="请选择技术老师" clearable size="small" remote :remote-method="technicianFilter" :loading="loading">
              <el-option :label="`${item.realName}（${item.levelName}）${item.mobile}`" :value="item.id" v-for="item in options.technicianList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="技术老师级别：">
            <el-select v-model="query.levelId" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(item,index) in options.technicianLevelList" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门：">
            <el-select v-model="query.deptId" placeholder="请选择" filterable clearable size="small" @change="changDepartment">
              <el-option v-for="(item,index) in options.departmentList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户类型：">
            <el-select v-model="query.isCustomerXin" placeholder="请选择" clearable size="small">
              <el-option label="新客户" :value="0"></el-option>
              <el-option label="老客户" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户分类：">
            <el-select v-model="query.customerClassifyId" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(item,index) in options.customerClass" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <template v-if="echartData && echartData.yAxisData.length > 0">
        <div class="title-txt">服务次数统计</div>
        <echarts-vue :echart-data="echartData" echartName="echarts" v-if="echartData && echartData.yAxisData" />
      </template>
      <template v-if="echartData1 && echartData1.yAxisData.length > 0">
        <div class="title-txt">收款统计</div>
        <echarts-vue :echart-data="echartData1" echartName="echarts" v-if="echartData1 && echartData1.yAxisData" />
      </template>
      <template v-if="echartData2 && echartData2.yAxisData.length > 0">
        <div class="title-txt">出货统计</div>
        <echarts-vue :echart-data="echartData2" echartName="echarts" v-if="echartData2 && echartData2.yAxisData" />
      </template>
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import DataBoardApi from '@/api/dataBoard/DataBoard'
import echartsVue from "../components/echarts.vue";
import technicianInfoApi from '@/api/technical/technicianInfo'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
import sysDepartmentApi from '@/api/config/sysDepartment'
import customerClassifyApi from '@/api/config/customerClassify'
import { formatDate, getCurrentMonthEnd, get6MonthStart } from '@/utils/index'
export default {
  components: {
    Pagination,
    echartsVue
  },
  data() {
    return {
      list: [],
      listLoading: true,
      total: 0,
      query: {
        timeType: 3
      },
      echartsData: [],
      echartsData1: [],
      echartsData2: [],
      xData: [],
      formRules: {
        // day: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }]
      },
      options: {
        technicianList: [],  //技术老师
        technicianLevelList: [], //技术老师级别
        departmentList: [],  //部门
        customerClass: [],  //客户类型
      },
      minDate: '',  //这两个值一定要定义
      maxDate: '',
      busTime: [],
      executeTimeOptions: {
        disabledDate: (time) => {
          if (this.minDate && this.maxDate) {
            //  this.maxDate  = new Date(this.maxDate).getTime();我是直接获取的时间戳，如果后台返回的格式不同，因为这里是对比的时间戳，所以在这里转换格式或者获取的时候转换成时间戳都可以,
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > this.maxDate || time.getTime() < this.minDate;
            //这里是大于结束日期和小于开始日期，小于今天的日期都不可选择
          }
        }
      }
    }
  },
  created() {
    // this.getEcharts()
    this.getTechnicianList()
    this.getTechnicianLevelList()
    this.getDepOption()
    this.getCustomerClass()
    this.getDate()
  },
  methods: {
    handleFilter() {
      this.query = {
        timeType: 3
      }
      this.getDate()
    },
    getDate() {
      let minDate = formatDate(get6MonthStart(5)) + ' 00:00:00'
      let maxDate = formatDate(getCurrentMonthEnd()) + ' 23:59:59'
      this.busTime = [minDate, maxDate]
    },
    //获取客户分类
    getCustomerClass() {
      customerClassifyApi.findOptions().then(res => {
        this.options.customerClass = res.data.reverse()
      })
    },
    // 获取部门
    getDepOption() {
      sysDepartmentApi.getMiniList().then(({ data }) => {
        this.options.departmentList = data.list
      })
    },
    // 获取技术老师列表
    getTechnicianList(e) {
      let obj = { status: 10, pageNo: 1, pageSize: 100 }
      obj.realName = e
      technicianInfoApi.fetchList(obj).then(({ data }) => {
        this.options.technicianList = data.list;
        this.$forceUpdate();
      })
    },
    technicianFilter(query) {
      this.searchData(query, 1)
    },
    //获取技术老师级别
    getTechnicianLevelList() {
      technicalServiceLevelApi.findOptions().then(({ data }) => {
        this.options.technicianLevelList = data;
      })
    },
    searchData(query, type) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          if (type === 1) this.getTechnicianList(query)
        }, 500);
      } else {
        // this.options = [];
      }
    },

    handleCommand(command) {
      this.query.timeType = +command
    },
    handleQuery() {
      let { timeType } = this.query;
      if (!this.busTime || (this.busTime && !this.busTime.length)) return this.$message.warning('请选择服务签到时间')
      if (!timeType) return this.$message.warning('请选择时间粒度')
      this.getPaymentStatis()
      this.getShipmentMoney()
      this.getShipmentTotal()
    },
    calcQuery() {
      let params = JSON.parse(JSON.stringify(this.query))
      params.startTime = this.busTime[0]
      params.endTime = this.busTime[1]
      return params
    },
    //服务次数统计
    getPaymentStatis() {
      let params = this.calcQuery()
      DataBoardApi.HumanServiceTotal(params).then(({ data }) => {
        if (data.length > 0) {
          // data.forEach(item => {
          //   item.ratio = Subtr(item.afterMoney, item.beforeMoney) / item.beforeMoney * 100;
          // })
          this.calcDate(data)
          this.getEcharts(data)
        } else {
          this.$message.warning('暂无数据')
        }
      })
    },
    //收款统计
    getShipmentMoney() {
      let params = this.calcQuery()
      DataBoardApi.HumanReceiveMoneyTotal(params).then(({ data }) => {
        if (data.length > 0) {
          // data.forEach(item => {
          //   item.ratio = Subtr(item.afterMoney, item.beforeMoney) / item.beforeMoney * 100;
          // })
          this.calcDate(data)
          this.getEcharts1(data)
        }
      })
    },
    //出货统计
    getShipmentTotal() {
      let params = this.calcQuery()
      DataBoardApi.HumanShipmentTotal(params).then(({ data }) => {
        if (data.length > 0) {
          // data.forEach(item => {
          //   item.ratio = Subtr(item.afterMoney, item.beforeMoney) / item.beforeMoney * 100;
          // })
          this.calcDate(data)
          this.getEcharts2(data)
        }
      })
    },
    calcDate(data) {
      let { timeType } = this.query;
      let dateList = []
      if (timeType === 1) {
        data.forEach(item => {
          item.date = item.startTime.substr(0, 10).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      } else if (timeType === 2) {
        data.forEach((item, index) => {
          let date = item.startTime.substr(0, 10).replace(/\-/g, "/")
          dateList.push(`第${index + 1}周 ${date}`)
        });

      } else if (timeType === 3) {
        data.forEach(item => {
          item.date = item.startTime.substr(0, 7).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      }
      this.xData = dateList
    },

    getEcharts(echartsData) {
      this.echartsData = this.synthesisSeriesData(echartsData, [
        { name: "服务次数", color: "#FED15C", key: "serviceTimes" },
        { name: "服务客户", color: "#F3715B", key: "serviceCount" },
      ], "line")
    },
    getEcharts1(echartsData) {
      this.echartsData1 = this.synthesisSeriesData(echartsData, [
        { name: "收款", color: "#FED15C", key: "money" },
        { name: "服务客户", color: "#F3715B", key: "serviceCount" },
      ], "line")
    },
    getEcharts2(echartsData) {
      this.echartsData2 = this.synthesisSeriesData(echartsData, [
        { name: "出货", color: "#FED15C", key: "serviceTimes" },
        { name: "服务客户", color: "#F3715B", key: "serviceCount" },
      ], "line")
    },
    //合成图标Y轴信息
    synthesisSeriesData(datalist, ydata, chartType) {
      let param = {}, itemStyle = {};
      if (chartType === 'line') {
        param = { type: "line", smooth: true, symbolSize: 10 };
      }
      return ydata.map(item => {
        return {
          name: item.name, ...param, data: datalist.map(it => it[item.key]), itemStyle: {
            ...itemStyle,
            color: item.color
          }
        }
      })
    }

  },
  computed: {
    echartData() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData
      };
    },
    echartData1() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData1
      };
    },
    echartData2() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData2
      };
    }
  },
}
</script>
<style lang="scss" scoped>
.down {
  width: 34px;
  height: 34px;
  cursor: pointer;
}
.flex-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.el-dropdown {
  line-height: 42px;
  margin-right: 10px;
  cursor: pointer;
  vertical-align: top;
}
</style>
